import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5242f37a")

_pushScopeId("data-v-5242f37a")
const _hoisted_1 = { class: "time" }
const _hoisted_2 = { class: "info break-word" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    onClosed: _ctx.closed,
    modal: false,
    top: `${15+_ctx.alarmCountTotal}vh`,
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = $event)),
    title: _ctx.$wordList.EmergencyAction,
    width: "30%"
  }, {
    footer: _withId(() => [
      _createVNode(_component_cus_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.dialogVisible = false;})
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSure), 1)
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.alarmInfo.ProjectName) + " " + _toDisplayString(_ctx.alarmInfo.CreateTime), 1),
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.wordList.format(_ctx.alarmInfo.Location)), 1)
    ]),
    _: 1
  }, 8, ["onClosed", "top", "modelValue", "title"]))
})